import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
export default {
  getCounselorList (ctx, data) {
    return fetch.getCounselorList(data).then(res => {
      res.data.forEach(ele => {
        ele.hospitalNum = ele.hospitals ? ele.hospitals.length : ''
      })
      return getTotalNumber(res)
    })
  },
  getPosition (ctx, data) {
    return fetch.getPosition(data).then(res => {
      return res.data
    })
  },
  createPosition (ctx, data) {
    return fetch.createPosition(data).then(res => {
      return res.data
    })
  },
  getCompany (ctx, data) {
    return fetch.getCompany(data).then(res => {
      return res.data
    })
  },
  createCompany (ctx, data) {
    return fetch.createCompany(data).then(res => {
      return res.data
    })
  },
  createCounselor (ctx, data) {
    return fetch.createCounselor(data).then(res => {
      return res.data
    })
  },
  updateCounselor (ctx, data) {
    return fetch.updateCounselor(data).then(res => {
      return res.data
    })
  },
  deleteCounselor (ctx, id) {
    return fetch.deleteCounselor(id).then(res => {
      return res.data
    })
  },
  getCounselor (ctx, id) {
    return fetch.getCounselor(id).then(res => {
      return res.data
    })
  },
  counselorFind (ctx, data) {
    return fetch.counselorFind(data).then(res => {
      // 咨询师执业医院数量不显示bug
      res.data.forEach(ele => {
        ele.hospitalNum = ele.hospitals ? ele.hospitals.length : ''
      })
      // res.data.forEach(ele => {
      //   ele.category = formatDetectionCategory(ele.category)
      // })
      return getTotalNumber(res)
    })
  },
  counselorDeparture (ctx, id) {
    return fetch.counselorDeparture(id).then(res => {
      return res
    })
  },
  getHasMallUser (ctx, mobile) {
    return fetch.getHasMallUser(mobile).then(res => {
      return res.data
    })
  },
  getCounselorCodeZip (ctx, data) {
    return fetch.getCounselorCodeZip(data).then(res => {
      return res.data
    })
  },
  exportCounselors (ctx, data) {
    return fetch.exportCounselors(data).then(res => {
      return res.data
    })
  },
  getCounselorQrCode (ctx, id) {
    return fetch.getCounselorQrCode(id).then(res => {
      return res.data
    })
  }
}
